import { EyeActivityDataModel } from "@/domain/entity/prescription/prescription-info-entity";
import { PrescriptionRepository } from "@/domain/repository/prescription-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FetchEyeActivityDataUsecase {
  constructor(private readonly prescriptionRepo: PrescriptionRepository) {}

  async execute(activityUuid: string): Promise<SATResult<EyeActivityDataModel, SATError>> {
    return this.prescriptionRepo.fetchEyeActivityData(activityUuid);
  }
}
